import React from 'react';
import Header from './components/Header'
import CreatePost from './components/CreatePost';
import PostList from './components/PostList';
import { PostProvider } from './context/PostContext';
import './App.css';

function App(){
    return(
        <PostProvider>
            <div classname="App">
                <Header/>
                <CreatePost/>
                <PostList/>
            </div>
            </PostProvider>
    );
}

export default App;